import { WebsocketEventsType } from '../types';

export interface OmniWebsocketDataInterface {
  event: WebsocketEventsType;
  data: any;
}
